import moment from 'moment'

// dates and times

export function getMoment(date) {
    return date ? moment(date) : null
}

export function shortTime(date) {
    return date ? moment(date).format('h:mma') : ""
}

export function shortStartStopTime(startDate, stopDate) {
    let mStart = moment(startDate)

    if (!stopDate) {
        return mStart.format('h:mm A') + " - now"
    }

    let mStop = moment(stopDate)
    const shareAMPM = mStart.format('a') === mStop.format('a')

    const startStr = mStart.format('m') === '0'
        ?  shareAMPM ? mStart.format('h') : mStart.format('h A')
        :  shareAMPM ? mStart.format('h:mm') : mStart.format('h:mm A')

    const stopStr = mStop.format('m') === '0'
        ?  mStop.format('h A')
        :  mStop.format('h:mm A')

    return startStr + " - " + stopStr
}

export function shortDate(date) {
    return date ? moment(date).format('YYYY-MM-DD') : ""
}

export function numDate(date) {
    return date ? moment(date).format("MM/DD/YYYY") : ""
}

export function numDateShortYear(date) {
    return date ? moment(date).format("M/D/YY") : ""
}

export function numDateShort(date) {
    return date ? moment(date).format("M/D/YYYY") : ""
}

export function today() {
    return this.ShortDate(new Date())
}

export function longTime(date) {
    return moment(date).format('h:mm:ss a')
}

export function weekdayAndDate(date) {
    return moment(date).format("dddd, MMMM Do YYYY")
}

export function weekday(date) {
    return moment(date).format("dddd")
}

export function weekdayShort(date) {
    return moment(date).format("ddd")
}

export function date(date) {
    return moment(date).format('MMMM Do YYYY')
}

export function medDate(date) {
    return moment(date).format('MMM D YYYY')
}

export function toJsDate(date) {
    return moment(date).toDate()
}

export function toUnix(date) {
    return date ? moment(date).unix() : null
}

export function fromUnixToJs(date) {
    return moment.unix(date).valueOf() // store date/time as milliseconds
}

export function convertTimeEntryToUnix(timeEntry) {
    const { startAt, endAt, updatedAt=0, duration=0, ...meta } = timeEntry // eslint-disable-line no-unused-vars
    return {
        ...meta,
        duration: toUnix(duration),
        startAt: toUnix(startAt),
        endAt: toUnix(endAt),
        updatedAt: toUnix(updatedAt),
    }
}

export function convertTimeEntryToJs(timeEntry) {
    const { startAt, endAt, updatedAt=0, duration, ...meta } = timeEntry // eslint-disable-line no-unused-vars
    return {
        ...meta,
        duration: duration * 1000,
        startAt: startAt * 1000,
        endAt: endAt * 1000,
        updatedAt: updatedAt * 1000,
    }
}



// WEBPACK FOOTER //
// ./src/util/fmt_utils.js